import { Component, OnInit, ViewChild } from '@angular/core';
import {
  PoBreadcrumb,
  PoDialogService,
  PoPageAction,
  PoPageFilter,
  PoPageListComponent,
  PoTableAction,
  PoTableColumn,
  PoTableColumnSpacing,
  PoTableComponent,
  PoComboComponent,
  PoModalAction,
  PoModalComponent,
  PoComboOption
} from '@po-ui/ng-components';
import { environment } from '../../../environments/environment';
import { SchemaBuilderService } from '../../core/menu/schema-builder.service';
import { HttpClient } from '@angular/common/http';
import { ListDataDto } from '../../core/common/list-data-dto';
import { Router } from '@angular/router';
import { ShortcutService } from '../../core/shortcut/shortcut.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-transferencia-fichas',
  templateUrl: './transferencia-fichas.component.html',
  standalone: false
})
export class TransferenciaFichasComponent implements OnInit {
  @ViewChild('dynamicTable', { static: true }) dynamicTable!: PoTableComponent;
  @ViewChild('pageListComponent', { static: true }) pageListComponent!: PoPageListComponent;
  @ViewChild('advancedFilterModal', { static: true }) advancedFilterModal!: PoModalComponent;
  @ViewChild('poComboCliente', { static: true }) clienteCombo!: PoComboComponent;

  isHideLoading = true;
  tableItens: any[] = [];
  columns: Array<PoTableColumn> = [];
  poTableColumnSpacing: PoTableColumnSpacing = PoTableColumnSpacing.Small;

  moreItens = false;
  page = 1;
  pageSize = 15;
  filter = '';
  selectedCliente?: number;
  selectedClienteName?: string;
  clienteFilter?: number;
  clientesOptions: Array<PoComboOption> = [];
  disclaimerGroup: any;
  private disclaimers: any[] = [];
  private updatingDisclaimers = false;

  private shortcutSubscription: Subscription;
  public readonly filterSettings: PoPageFilter = {
    action: this.filterAction.bind(this),
    advancedAction: this.openAdvancedFilterModal.bind(this),
    placeholder: 'Pesquisar'
  };

  readonly advancedFilterPrimaryAction: PoModalAction = {
    action: () => {
      this.pageListComponent.clearInputSearch();
      this.advancedFilterModal.close();
      this.clienteFilter = this.selectedCliente;
      this.updateDisclaimers();
    },
    label: 'Aplicar filtro'
  };

  readonly serviceApi = `${environment.apiUrl}${environment.versionApi}/transferencia-ficha`;
  readonly clientServiceApi = `${environment.apiUrl}${environment.versionApi}${environment.clienteServiceApi}`;

  readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'CAT 83/2009' },
      { label: 'Dados de Processamento' },
      { label: 'Movimenta\u00e7\u00e3o' },
      { label: 'Transfer\u00eancia de Fichas' }
    ]
  };

  readonly pageActions: Array<PoPageAction> = [
    {
      label: 'Nova Transfer\u00eancia',
      action: () => this.router.navigate(['/transferencia-fichas-edit']),
      icon: 'an an-plus'
    },
    {
      label: 'Atualizar',
      action: () => this.resetTable(),
      icon: 'an an-arrows-clockwise'
    }
  ];

  readonly actions: PoTableAction[] = [
    {
      label: 'Editar Registro',
      action: this.edit.bind(this),
      icon: 'an an-pencil',
      type: 'default'
    },
    {
      label: 'Deletar Registro',
      action: this.confirmDelete.bind(this),
      icon: 'an an-trash',
      type: 'danger',
      separator: true
    }
  ];

  constructor(
    private readonly schemaBuilderService: SchemaBuilderService,
    private readonly poDialogService: PoDialogService,
    private readonly shortcutService: ShortcutService,
    private readonly router: Router,
    private readonly http: HttpClient
  ) {
    this.schemaBuilderService.getTableSchemaNew('transferencia-fichas').subscribe(data => {
      this.columns = data;
    });

    this.shortcutSubscription = this.shortcutService.getShortcuts().subscribe((event: KeyboardEvent) => {
      if (event.ctrlKey && event.key === 'b') {
        event.preventDefault();
        this.router.navigate(['/transferencia-fichas-edit']);
      } else if (event.ctrlKey && event.key === 'f') {
        event.preventDefault();
        this.pageListComponent.filterInput.nativeElement.focus();
      }
    });
  }

  ngOnInit() {
    this.disclaimerGroup = {
      title: 'Filtros:',
      disclaimers: [],
      change: this.onChangeDisclaimer.bind(this),
      remove: this.onClearDisclaimer.bind(this),
      removeAll: this.onClearAllDisclaimer.bind(this)
    };
    this.loadMore();
  }

  chageCliente(cliente: any) {
    this.selectedCliente = cliente.value;
    this.selectedClienteName = cliente.label;
  }

  openAdvancedFilterModal() {
    this.advancedFilterModal.open();
  }

  updateDisclaimers() {
    const disclaimers = [] as Array<{ value: string; property: string }>;

    this.updatingDisclaimers = true;

    if (this.filter) {
      disclaimers.push({ value: this.filter, property: 'search' });
    }

    if (this.clienteFilter) {
      const label = this.selectedClienteName;
      const value = label ? `Cliente: ${label}` : `Cliente: ${this.clienteFilter}`;
      disclaimers.push({ value, property: 'cliente' });
    }

    this.disclaimers = [...disclaimers];
    this.disclaimerGroup.disclaimers = [...disclaimers];
    this.updatingDisclaimers = false;
  }

  filterAction(searchValue: string | Array<string>) {
    this.filter = Array.isArray(searchValue) ? searchValue.join(', ') : searchValue;
    this.updateDisclaimers();
    this.loadMore(true);
  }

  confirmDelete(item: any) {
    this.poDialogService.confirm({
      title: 'Exclus\u00e3o de Registros',
      message: `Deseja realmente excluir o item selecionado?`,
      confirm: () => this.remove(item)
    });
  }

  remove(item: any) {
    this.isHideLoading = false;
    this.http.delete(`${this.serviceApi}/${item.id}`).subscribe(
      () => {
        this.dynamicTable.removeItem(item);
        this.isHideLoading = true;
      },
      error => {
        console.error('Error deleting item:', error);
        this.isHideLoading = true;
      }
    );
  }

  edit(item: any) {
    this.router.navigate(['/transferencia-fichas-edit', item.id]);
  }

  resetTable() {
    this.loadMore(true);
  }
  onChangeDisclaimer(disclaimers: any) {
    if (this.updatingDisclaimers) {
      return;
    }
    this.disclaimers = disclaimers;
    this.loadMore(true);
  }

  onClearDisclaimer(disclaimers: any) {
    if (disclaimers.removedDisclaimer.property === 'search') {
      this.pageListComponent.clearInputSearch();
      this.filter = '';
    }

    if (disclaimers.removedDisclaimer.property === 'cliente') {
      this.clienteFilter = undefined;
      this.selectedCliente = undefined;
      this.selectedClienteName = undefined;
      this.clienteCombo.clearAndFocus();
    }

    this.updateDisclaimers();
    this.loadMore(true);
  }

  onClearAllDisclaimer() {
    this.filter = '';
    this.clienteFilter = undefined;
    this.selectedCliente = undefined;
    this.selectedClienteName = undefined;

    this.pageListComponent.clearInputSearch();
    this.clienteCombo.clearAndFocus();

    this.disclaimers = [];
    this.disclaimerGroup.disclaimers = [];

    this.loadMore(true);
  }

  loadMore(reset: boolean = false): void {
    this.isHideLoading = false;
    const clienteParam = this.clienteFilter ? `&idCliente=${this.clienteFilter}` : '';
    if (reset) {
      this.page = 1;
      this.http
        .get<ListDataDto>(`${this.serviceApi}?page=${this.page}&pageSize=${this.pageSize}&search=${this.filter}${clienteParam}`)
        .subscribe(
          data => {
            this.tableItens = [];
            this.tableItens = [...this.tableItens, ...data.items];
            this.moreItens = data.hasNext;
            this.page++;
            this.isHideLoading = true;
          },
          error => {
            console.log(error);
            this.isHideLoading = true;
          }
        );
    } else {
      this.http
        .get<ListDataDto>(`${this.serviceApi}?page=${this.page}&pageSize=${this.pageSize}&search=${this.filter}${clienteParam}`)
        .subscribe(
          data => {
            this.tableItens = [...this.tableItens, ...data.items];
            this.moreItens = data.hasNext;
            this.page++;
            this.isHideLoading = true;
          },
          error => {
            console.log(error);
            this.isHideLoading = true;
          }
        );
    }
  }
}
